import {Dropdown} from "react-bootstrap";
import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";
import PopupEditAnimal from "./PopupEditAnimal";
import PopupDeleteAnimal from "./PopupDeleteAnimal";


export default function AnimalActions({item, setLoadData, baseUrl}) {

    return <Dropdown drop='down-centered'>
        <Dropdown.Toggle
            variant="secondary"
        >
            Ações &nbsp;
            <SettingsIcon fontSize="medium"/>
        </Dropdown.Toggle>

        <Dropdown.Menu>
            <PopupEditAnimal item={item} baseUrl={baseUrl} setLoadData={setLoadData}/>
            <PopupDeleteAnimal item={item} baseUrl={baseUrl} setLoadData={setLoadData}/>
        </Dropdown.Menu>

    </Dropdown>
}